<script setup>
import { TooltipRoot, useForwardPropsEmits } from "reka-ui";

const props = defineProps({
  defaultOpen: { type: Boolean, required: false, default: undefined },
  open: { type: Boolean, required: false, default: undefined },
  delayDuration: { type: Number, required: false },
  disableHoverableContent: { type: Boolean, required: false, default: undefined },
  disableClosingTrigger: { type: Boolean, required: false, default: undefined },
  disabled: { type: Boolean, required: false, default: undefined },
  ignoreNonKeyboardFocus: { type: Boolean, required: false, default: undefined },
});
const emits = defineEmits(["update:open"]);

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
  <TooltipRoot v-bind="forwarded">
    <slot />
  </TooltipRoot>
</template>
